<div class="top-section">
    <h3>
     My Open Cargo List
    </h3>
  </div>
  <section class="rate-request rate-request-sec">
    <div class="middle-section">
      <div class="container">
        <div class="rate-request-form">
          <div class="rate-request-form-inner">
            <div class="pRel">
              <select class="form-control" style="padding:0px 21px 2px" (change)="statusValue($event.target.value)"
                [(ngModel)]="selectrateStatus">
                <option *ngFor="let name of options" [value]="name">{{name}} </option>
              </select>
              <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
            </div>
            <div class="pRel" style="width: 17%;">
              <select class="form-control" style="padding:0px 21px 2px" (change)="onDurationChange($event.target.value)"
                [(ngModel)]="selectedDuration">
                <option *ngFor="let duration of durationValues" [value]="duration">{{durationFilterOptions[duration]}}
                </option>
              </select>
              <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
            </div>
            <div class="request-btn">
              <!-- <i class="fa fa-search" style="margin:4px 4px 0 0"></i> -->
              <input type="text" class="form-control" pInputText size="50" placeholder="Search"
                (change)="filterSearch($event.target.value)">
              <div class="btn-search"><button class="btn  btn-go my-2 my-sm-0" type="submit"><img
                    src="../../../assets/images/Group 103.svg"></button></div>
            </div>
            <!-- *ngIf="!isadmin" -->
            <div class="make-rate-request" *ngIf="!isadmin">
              <a class="btn btn-signIn" href="javascript:void(0)" (click)="AddRateRequest()">
                <i class="fa fa-plus"></i> Post Cargo</a>
            </div>
          </div>
          <div class="table-responsive rate-request-tbl">
  
            <p-table [value]="RatelistData">
  
              <ng-template pTemplate="header">
                <tr>
                  <th>Request No.</th>
                  <th>From Port</th>
  
                  <th>To Port</th>
                  <th>Cargo Class</th>
                  <th>Cargo Ready In Loadport</th>
                  <!-- <th>User Name</th> -->
                  <th>No Of Units</th>
                  <th>Shipping Cost($)</th>
                  <th>Status</th>
                  <th width="140"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rate>
                <tr>
                  <td>{{rate.rateRequestNumber}}</td>
                  <td>{{ rate.fromPort }}</td>
                  <td>{{ rate.toPort }}</td>
                  <td>{{ rate.cargoType }}</td>
                  <td>{{ rate.whenCargoCanLandport | date: "dd-MM-yyyy" }}</td>
                  <!-- <td class="text-break">{{ rate.userName }}</td> -->
                  <td>{{ rate.noOfUnits }}</td>
                  <td *ngIf="rate.offeredRate">${{ rate.offeredRate }}</td>
                  <td *ngIf="!rate.offeredRate">{{ rate.offeredRate }}</td>
                  <td><span class="badge badge-awaiting-offer"
                      *ngIf="rate.status == raterqueststatus.AwaitingOffers">Awaiting Offers</span>
                    <span class="badge badge-offer-received" *ngIf="rate.status == raterqueststatus.OfferReceived">
                      Offers Received </span>
                    <span class="badge badge-awaiting-book-confirm"
                      *ngIf="rate.status == raterqueststatus.AwaitingBookingConfirmation"> Awaiting Booking Conformation
                    </span>
                    <span class="badge badge-confirmed" *ngIf="rate.status == raterqueststatus.BookingConfirmed"> Booking
                      Conformed </span>
                    <span class="badge badge-re-rate-request" *ngIf="rate.status == raterqueststatus.ReRequest">
                      Re-Request </span>
                  <td class="text-center">
                    <a *ngIf="isadmin || CanGiveQuotation" class="action-btn " tooltipPosition="top"
                      pTooltip="View Rate Request" data-toggle="modal" data-target=".add-modal"
                      (click)="openRateRequestModel(rate.id,rate.fromPort,rate.toPort,rate.status,rate.offeredRateId)">
                      <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18px"
                        height="18px" fill="#505d6b">
                        <path
                          d="M 7.5 1 C 3.917969 1 1 3.917969 1 7.5 C 1 11.082031 3.917969 14 7.5 14 C 11.082031 14 14 11.082031 14 7.5 C 14 3.917969 11.082031 1 7.5 1 Z M 7.5 2 C 10.542969 2 13 4.457031 13 7.5 C 13 10.542969 10.542969 13 7.5 13 C 4.457031 13 2 10.542969 2 7.5 C 2 4.457031 4.457031 2 7.5 2 Z M 7 4 L 7 7 L 4 7 L 4 8 L 7 8 L 7 11 L 8 11 L 8 8 L 11 8 L 11 7 L 8 7 L 8 4 Z" />
                      </svg>
                    </a>
                    <!-- <a *ngIf="!isadmin && rate.status != 1" class="action-btn " tooltipPosition="top" pTooltip="View Rate"
                      data-toggle="modal" data-target=".view-modal"
                      (click)="GetOfferdRate(rate.id,rate.fromPort,rate.toPort)">
                      <i class="fa fa-eye"></i>
                    </a> -->
  
                    <span data-toggle="tooltip" data-placement="top" (click)="editRaterequest(rate.id)"
                      tooltipPosition="top" pTooltip="Edit" class="action-btn"
                      *ngIf="IsRateEdit && rate.status != raterqueststatus.BookingConfirmed">
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 469.331 469.331"
                        style="enable-background:new 0 0 469.331 469.331; height: 15px;" xml:space="preserve"
                        fill="#505d6b">
                        <g>
                          <path d="M438.931,30.403c-40.4-40.5-106.1-40.5-146.5,0l-268.6,268.5c-2.1,2.1-3.4,4.8-3.8,7.7l-19.9,147.4
                    c-0.6,4.2,0.9,8.4,3.8,11.3c2.5,2.5,6,4,9.5,4c0.6,0,1.2,0,1.8-0.1l88.8-12c7.4-1,12.6-7.8,11.6-15.2c-1-7.4-7.8-12.6-15.2-11.6
                    l-71.2,9.6l13.9-102.8l108.2,108.2c2.5,2.5,6,4,9.5,4s7-1.4,9.5-4l268.6-268.5c19.6-19.6,30.4-45.6,30.4-73.3
                    S458.531,49.903,438.931,30.403z M297.631,63.403l45.1,45.1l-245.1,245.1l-45.1-45.1L297.631,63.403z M160.931,416.803l-44.1-44.1
                    l245.1-245.1l44.1,44.1L160.931,416.803z M424.831,152.403l-107.9-107.9c13.7-11.3,30.8-17.5,48.8-17.5c20.5,0,39.7,8,54.2,22.4
                    s22.4,33.7,22.4,54.2C442.331,121.703,436.131,138.703,424.831,152.403z" />
                        </g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                      </svg>
                    </span>
  
                    <a class="action-btn assign-edit-btn"
                      *ngIf="!isadmin && rate.status == raterqueststatus.AwaitingOffers" tooltipPosition="top"
                      pTooltip="Delete" (click)="DeleteRateRequest(rate.id)">
  
                      <svg id="trash" xmlns="http://www.w3.org/2000/svg" width="17" height="17 " viewBox="0 0 14 15.928">
                        <path id="Path_274" data-name="Path 274"
                          d="M3.267,15.928h7.466a1.4,1.4,0,0,0,1.4-1.4v-8.9h1.4a.467.467,0,1,0,0-.933h-.5A3.282,3.282,0,0,0,9.8,1.867H9.334V1.4A1.4,1.4,0,0,0,7.934,0H6.067a1.4,1.4,0,0,0-1.4,1.4v.467H4.2A3.282,3.282,0,0,0,.967,4.7h-.5a.467.467,0,1,0,0,.933h1.4v8.9a1.4,1.4,0,0,0,1.4,1.4Zm7.933-1.4a.467.467,0,0,1-.467.467H3.267a.467.467,0,0,1-.467-.467v-8.9h8.4ZM5.6,1.4A.467.467,0,0,1,6.067.933H7.934A.467.467,0,0,1,8.4,1.4v.467H5.6ZM4.2,2.8H9.8a2.345,2.345,0,0,1,2.287,1.9H1.913A2.345,2.345,0,0,1,4.2,2.8Zm0,0"
                          fill="#505d6b" />
                        <path id="Path_275" data-name="Path 275"
                          d="M135.467,246.631a.467.467,0,0,0,.467-.467v-4.7a.467.467,0,0,0-.933,0v4.7A.467.467,0,0,0,135.467,246.631Zm0,0"
                          transform="translate(-130.8 -233.503)" fill="#505d6b" />
                        <path id="Path_276" data-name="Path 276"
                          d="M210.467,246.631a.467.467,0,0,0,.467-.467v-4.7a.467.467,0,1,0-.933,0v4.7A.467.467,0,0,0,210.467,246.631Zm0,0"
                          transform="translate(-203.466 -233.503)" fill="#505d6b" />
                        <path id="Path_277" data-name="Path 277"
                          d="M285.467,246.631a.467.467,0,0,0,.467-.467v-4.7a.467.467,0,1,0-.933,0v4.7A.467.467,0,0,0,285.467,246.631Zm0,0"
                          transform="translate(-276.133 -233.503)" fill="#505d6b" />
                      </svg>
                    </a>
  
                    <a *ngIf="rate.status != raterqueststatus.AwaitingOffers" class="action-btn text-success"
                      tooltipPosition="top" pTooltip="View Offered Rates" data-toggle="modal"
                      data-target=".view-offredrate" (click)="openOfferedRateModal(rate.id)">
                      <i class="fa fa-eye"></i>
                    </a>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <p-paginator *ngIf="totalcount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
            [totalRecords]="totalcount" (onPageChange)="paginate($event)"></p-paginator>
          <div *ngIf="totalcount == 0">
            <span>No records found</span>
          </div>
          <button *ngIf="Isopenpopup" id="openpopup" data-toggle="modal" class="btn btn-orange2 round-btn "
            data-target=".add-modal">OpenPopup</button>
          <button *ngIf="viewoffer" id="openpopupNew" data-toggle="modal" class="btn btn-orange2 round-btn "
            data-target=".view-offredrate">up</button>
        </div>
      </div>
    </div>
  </section>
  <!-- <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog> -->
  <p-confirmDialog header="Delete !" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  
  <div class="modal fade add-modal request-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
    aria-hidden="true">
    <form [formGroup]="RateForm" (ngSubmit)="SubmitRate()">
      <div class="modal-dialog modal-lg">
        <div class="modal-content text-left">
          <div class="modal-header">
  
            <h5 class="modal-title ">Freight Request Summary</h5>
            <div class="float-right btn btn-signIn" *ngIf="statusrate == raterqueststatus.ReRequest">
              <strong>Re-Rate Requested</strong>
            </div>
            <button type="button" data-dismiss="modal" aria-label="Close" class="close-btn" #closeRateModalsub>
              <span class="pi pi-fw pi-times"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="ports">
              <div class="portleft">
                <div class="form-group">
                  <label class="custom-labal ">
                    From Port
                  </label>
                  <span>
                    {{frmport}}
                  </span>
                </div>
                <span class="arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="54.963" height="6.658" viewBox="0 0 54.963 6.658">
                    <defs>
                      <style>
                        .a {
                          fill: #c2cadb;
                        }
                      </style>
                    </defs>
                    <path class="a"
                      d="M-40.135,35.387c2.834.005,47.913.131,50.747.077-.305.308-.607.62-.9.94-.771.846.483,2.108,1.258,1.258.856-.939,1.773-1.816,2.714-2.669a.8.8,0,0,0-.033-1.245.959.959,0,0,0-.236-.241c-.874-.629-1.712-1.3-2.534-2-.87-.737-2.135.516-1.258,1.258q.548.464,1.109.912c-2.874.06-47.993-.068-50.867-.073A.89.89,0,0,0-40.135,35.387Z"
                      transform="translate(40.996 -31.286)" />
                  </svg>
  
                </span>
                <div class="form-group">
                  <label class="custom-labal ">
                    To Port
                  </label>
                  <span>
                    {{toport}}
                  </span>
                </div>
              </div>
              <div class="portright">
                <div class="form-group">
                  <span class="custom-labal ">Offered Rate :</span>
                  <span class="btn bg-success">${{offeredamount}}</span>
                </div>
                <div class="form-group" *ngIf="statusrate == raterqueststatus.ReRequest">
                  <span class="custom-labal ">Reason For Re- Request:</span>
                  <span><strong>{{offeredRateReason}}</strong></span>
                </div>
              </div>
  
            </div>
            <div class="row mt-3 mb-3">
              <!-- <div class="col-md-12 form-group">
                <button class="btn btn-signIn" data-toggle="modal" data-target=".view-poprereq"> Re-Rate
                  Request</button>
              </div> -->
            </div>
            <div class="form-group m-t-30">
              <h5 class="modal-title mb-3 mt-3 ">User Details</h5>
              <hr class="hr-1 ">
              <div *ngIf="showUserDetails" class="row m-t-30">
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Name
                  </label>
                  <div class="pRel">
                    {{rateRequestUserDetail?.firstName}} {{rateRequestUserDetail?.lastName}}
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Company
                  </label>
                  <div class="pRel">
                    {{rateRequestUserDetail?.companyName}}
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Phone
                  </label>
                  <div class="pRel">
                    {{rateRequestUserDetail?.phoneNumber}}
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Email
                  </label>
                  {{rateRequestUserDetail?.email}}
                </div>
              </div>
              <div *ngIf="!showUserDetails" class="row m-t-30">
                <div class="col-md-12 form-group">
                  <b>Customer Details Locked</b><br />
                  Only <b>Elite Members</b> have direct access to customer contact information.
                  To unlock the customer details, please submit your quotation. The customer will review your offer and
                  may choose to contact you directly.
                  Upgrade to Elite to see customer details instantly and receive priority visibility for your quotes.
                </div>
              </div>
            </div>
  
            <div class="form-group m-t-30">
  
              <h5 class="modal-title mb-3 mt-3 ">Consignment Details</h5>
              <hr class="hr-1 ">
              <div class="row m-t-30">
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Cargo Class
                  </label>
                  <div class="pRel">
                    {{cargoclassname}}
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Cargo Segment
                  </label>
                  <div class="pRel">
                    {{cargosegmentname}}
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Condition
                  </label>
                  {{conditionname}}
                </div>
  
              </div>
              <div class="row m-t-30">
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Cargo Movement Status
                  </label>
                  {{cargoMovementStatus}}
                </div>
  
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    When can cargo be in loadport?
                  </label>
                  <div class="pRel">
                    {{whencargocanlandportname | date: "dd-MM-yyyy"}}
                  </div>
  
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Number of Units
                  </label>
                  {{numberofunitname}}
  
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Shipping Lines
                  </label>
                  <div class="pRel">
                    {{shippinglinename}}
                  </div>
  
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Length(m)
                  </label>
                  <div class="pRel">
                    {{cargolength}}
                  </div>
  
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal">
                    Width(m)
                  </label>
                  <div class="pRel">
                    {{cargowidth}}
                  </div>
  
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-labal">
                    Height(m)
                  </label>
                  <div class="pRel">
                    {{cargoheight}}
                  </div>
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-labal">
                    Weight(mt)
                  </label>
                  <div class="pRel">
                    {{cargoweight}}
                  </div>
                </div>
  
                <div class="col-md-3 form-group">
                  <label class="custom-labal">
                    Package And Description
                  </label>
                  <div class="pRel">
                    {{packageAndDescription}}
                  </div>
                </div>
  
                <div class="col-md-3 form-group">
                  <span *ngFor="let item of fileNames">
                    <a href="{{downloadBaseUrl}}{{item}}"><img src="../../../assets/images/fileicon.png" /></a>
                  </span>
                </div>
  
              </div>
              <hr class="hr-1 ">
              <div class="stripTotal">
                <div class="row">
                  <div class="col-md-4 form-group">
                    <label class="custom-labal ">
                      Total number of units
                    </label>
                    <input type="text" class="form-control" formControlName="noOfUnits" readonly />
                  </div>
                  <div class="col-md-4 form-group">
                    <label class="custom-labal ">
                      Total LaneMeters
                    </label>
                    <input type="text" formControlName="totallanemeters" class="form-control" readonly />
                  </div>
                  <div class="col-md-4 form-group">
                    <label class="custom-labal ">
                      Total Cubic Meters
                    </label>
                    <input type="text" class="form-control" formControlName="totalCubicmeters" readonly />
                  </div>
                </div>
              </div>
  
            </div>
            <hr class="hr-1 ">
            <h5 class="modal-title mb-3 mt-3 ">Freight request summary</h5>
            <div class="row ui-table">
              <div class="col-md-12 table-responsive   request-summary m-t-30">
                <table class="table table-striped nbr ">
                  <tr>
                    <th>Description</th>
                    <th>Rate Basis</th>
                    <th>Rate</th>
                    <th>Sum</th>
                  </tr>
                  <tr>
                    <td>
                      Freight Rate
                    </td>
                    <td>
                      <div class="pRel">
                        <p-dropdown [options]="freightratedropdown" formControlName="freightratebasis"
                          class="select-dropdown-sec " placeholder="Rate Basis" [filter]="false"
                          (onChange)="Calculatetotalfreightrate()"></p-dropdown>
                        <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                      </div>
                      <div *ngIf="hasError('freightratebasis', 'required') && submitted" class="invalid-Validation">
                        freight rate basis is required
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control " placeholder="0.00" name="my_field"
                        pattern="^-?\d*(\.\d{0,2})?$" (change)="Calculatetotalfreightrate()"
                        formControlName="freightrate" />
                      <div *ngIf="hasError('freightrate', 'required') && submitted" class="invalid-Validation">
                        freight rate is required
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control totalrate" formControlName="ratetotal" readonly />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      BAF
                    </td>
                    <td>
                      <div class="pRel">
                        <p-dropdown [options]="otherratedropdown" class="select-dropdown-sec" aria-readonly="!admin"
                          formControlName="bafbasis" placeholder="Rate Basis" (onChange)="CalculatetotalBAFtrate()"
                          [filter]="false">
                        </p-dropdown>
                        <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                      </div>
                      <div *ngIf="hasError('bafbasis', 'required') && submitted" class="invalid-Validation">
                        BAF Basis is required
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control " placeholder="0.00" name="my_field"
                        pattern="^-?\d*(\.\d{0,2})?$" (change)="CalculatetotalBAFtrate()" formControlName="baf" />
                      <div *ngIf="hasError('baf', 'required') && submitted" class="invalid-Validation">
                        BAF Rate is required
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control totalbaf" formControlName="baftotal" readonly />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <!-- CAF -->
                      Booking Fee
                    </td>
                    <td>
                      <div class="pRel">
                        <p-dropdown [options]="otherratedropdown" (onChange)="CalculatetotalCAFrate()"
                          class="select-dropdown-sec" formControlName="cafbasis" placeholder="Rate Basis" [filter]="false"
                          [readonly]="iscafbasisReadonly == true">
                        </p-dropdown>
                        <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                      </div>
                      <div *ngIf="hasError('cafbasis', 'required') && submitted" class="invalid-Validation">
                        Booking Fee is required
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control" placeholder="0.00" name="my_field"
                        pattern="^-?\d*(\.\d{0,2})?$" (change)="CalculatetotalCAFrate()" formControlName="caf" />
                    </td>
                    <td>
                      <input type="text" class="form-control totalcaf" formControlName="caftotal" readonly />
                    </td>
                  </tr>
  
                  <tr>
                    <td>
                      THC
                    </td>
                    <td>
                      <div class="pRel">
                        <p-dropdown [options]="otherratedropdown" formControlName="thcbasis" class="select-dropdown-sec"
                          (onChange)="CalculatetotalTHCrate()" placeholder="Rate Basis" [filter]="false"></p-dropdown>
                        <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                      </div>
                      <div *ngIf="hasError('thcbasis', 'required') && submitted" class="invalid-Validation">
                        THC Basis Rate is required
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control" placeholder="0.00" name="my_field"
                        pattern="^-?\d*(\.\d{0,2})?$" (change)="CalculatetotalTHCrate()" formControlName="thc" />
                      <div *ngIf="hasError('thc', 'required') && submitted" class="invalid-Validation">
                        THC Rate is required
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control totalthc" formControlName="thctotal" readonly />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Other Charges
                    </td>
                    <td>
                      <div class="pRel">
                        <p-dropdown [options]="otherratedropdown" formControlName="otherchargesbasis"
                          class="select-dropdown-sec" placeholder="Rate Basis" (onChange)="Calculatetotalothercharges()"
                          [filter]="false"></p-dropdown>
                        <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                      </div>
                      <div *ngIf="hasError('otherchargesbasis', 'required') && submitted" class="invalid-Validation">
                        Other Charges Basis Rate is required
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control" placeholder="0.00" name="my_field"
                        pattern="^-?\d*(\.\d{0,2})?$" (change)="Calculatetotalothercharges()"
                        formControlName="othercharges" />
                      <div *ngIf="hasError('othercharges', 'required') && submitted" class="invalid-Validation">
                        Other Charges Rate is required
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control totalothercharges" formControlName="otherchargestotal"
                        readonly />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Total Freight Cost
                    </td>
                    <td>
  
                    </td>
                    <td>
  
                    </td>
                    <td>
                      <input type="text" class="form-control totalsumofallcost" formControlName="totalsumofallcost"
                        readonly />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4" height="40">
  
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <hr class="hr-1 ">
            <h5 class="modal-title  ">Freight cost summary</h5>
            <div class="stripTotal">
              <div class="row ">
                <div class="col-md-3 form-group">
                  <label class="custom-labal ">
                    Cost per unit
                  </label>
                  <input type="text" class="form-control costperunt" formControlName="costperunit" readonly />
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-labal ">
                    Cost per CubicMeter
                  </label>
                  <input type="text" class="form-control costpercubicmeter" formControlName="costpercubicmeter"
                    readonly />
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-labal ">
                    Total Cost
                  </label>
                  <input type="text" class="form-control totalsumofallcost" formControlName="totalsumofallcost"
                    readonly />
                </div>
                <div class="col-md-3">
                  <label class="custom-labal ">
                    Freight Rate Validity
                  </label>
                  <!-- <input type="text" class="form-control" formControlName="freightratevalidity" readonly /> -->
                  <p-calendar [readonlyInput]="true" formControlName="freightratevalidity" showIcon="true"
                    showButtonBar="true" placeholder="Date" [minDate]="minDate" [monthNavigator]="true"
                    [yearNavigator]="true" yearRange="{{rageYears}}" icon="pi pi-calendar" iconPos="left"
                    dateFormat="dd-mm-yy">
                  </p-calendar>
                  <div *ngIf="hasError('freightratevalidity', 'required') && submitted" class="invalid-Validation">
                    Freight Rate Validity Date is required.
                  </div>
                </div>
              </div>
            </div>
            <hr class="hr-1 ">
            <div class="row ">
              <div class="col-md-12">
                <!-- <p>
                  <span class="text-orange">This rate quotation confirmation contains 12:</span>
                  the tariff ocean rates
                  global surcharges such as BAF, SRC and Canal Surcharge where applicable
                  validity date for these rates
                  standard Terms and Conditions that are applicable
                </p> -->
                <label class="custom-labal ">
                  Disclaimer
                </label>
  
                <textarea class="disclaimer" formControlName="disclaimer" rows="2" cols="100" pInputTextarea
                  autoResize="autoResize" placeholder="               The rate terms are FLT (Full Liner Terms)
                 ENL Solutions reserve the right to correct any omission or clerical error made in the quotation process
                 This rate quote is not considered a binding agreement. A booking confirmation is provided based on space and equipment availability and is based on accepting the lines terms and conditions, which are available upon request.
                 Please note cargo is freighted on actual dimensions at the terminal upon delivery, which may result upon higher rate than quoted.
                 BAF and CAF is included in freight rate unless specified in quote.
                 THC and other charges are not included in freight rate and is for shippers account 
                 B/L Fee is not included in rate offer. Price is available on request
                 "></textarea>
  
              </div>
            </div>
          </div>
          <!-- <button type="button" data-dismiss="modal" aria-label="Close" #closeRateModal>
            <span aria-hidden="true">
              <img src="../../assets/images/svgs/close-model.svg" width="15">
            </span>
          </button> -->
          <!-- <div class="form-group row"> -->
          <!-- <label class="col-md-12 col-form-label">Certification</label> -->
          <!-- <div class="col-md-12"> -->
          <!-- <input class="form-control" formControlName="rate" required placeholder="0.00"
              type="number"> -->
          <!-- <div *ngIf="fg.CertificateName.invalid && (fg.CertificateName.dirty || fg.CertificateName.touched)"
              class="text-left errormsg validfontadjust">
              <span *ngIf="fg.CertificateName.errors.required">
                Please enter a Certificate Name
              </span>
            </div> -->
          <!-- </div> -->
          <!-- </div> -->
          <div class="modal-footer">
            <button type="submit" class="btn btn-signIn ">Save</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal fade add-paymetpopup request-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
    aria-hidden="true" style="overflow: auto !important;">
    <!-- <form [formGroup]="RateForm" (ngSubmit)="SubmitRate()"> -->
    <div class="modal-dialog modal-lg">
      <div class="modal-content text-left">
        <div class="modal-header">
          <h5 class="modal-title ">Select Payment Method</h5>
          <button type="button" data-dismiss="modal" id="closepoup" aria-label="Close" class="close-btn"
            #closeRateModalsub>
            <span class="pi pi-fw pi-times"></span>
          </button>
          <button id="openModalButton" [hidden]="true" data-toggle="modal" data-target=".add-paymetpopup">Open
            Modal</button>
        </div>
        <div class="modal-body">
          <div class="row">
            <label>
              Total Amount : $ {{totalamount}}
            </label>
            <input type="text" class="data" value="{{totalamount}}" hidden>
          </div>
          <div id="paypal-button-container"></div>
        </div>
        <div class="modal-footer">
        </div>
      </div>
    </div>
  </div>


<ng-template #viewOfferedRate let-modal>
  <div class="modal-header">
    <h3>Offered Rates</h3>
    <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
      <span class="pi pi-fw pi-times"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th *ngIf="canbook"></th>
            <th>From Port</th>
            <th>To Port</th>
            <th>Offered By</th>
            <th>Shipping Cost($)</th>
            <th>Rate Valid Till</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let offereate of offeredratelist">
            <td *ngIf="canbook">
              <p-radioButton name="group1" value="{{offereate.offeredRateId}}" [(ngModel)]="selected" inputId="opt1"></p-radioButton>
            </td>
            <td width="40">{{offereate.fromPortName}}</td>
            <td>{{offereate.toPortName}}</td>
            <td>{{offereate.offeredBy}}</td>
            <td>{{offereate.totalOfferedRate }}</td>
            <td>{{offereate.freightRateValidTill | date:'dd-MM-yyyy'}}</td>
            <td>
              <a data-toggle="modal" data-target=".view-modal" (click)="openOfferedRateViewModal(offereate.rateRequestId,offereate.fromPortName,offereate.toPortName,offereate.offeredRateId)" class="text-success" tooltipPosition="top" pTooltip="View Details">
                <i class="fa fa-eye"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <strong class="booking-text" *ngIf="canbook">«When clicking «Booking request», your request will be sent directly to the rate provider.
They will contact you to confirm availability and finalize the quotation.</strong>
    <button type="submit" *ngIf="canbook" class="btn btn-signIn " (click)="OnRateSelection()">Booking request</button>
  </div>
</ng-template>

<ng-template #viewOfferedRateVM let-modal>
  <div class="modal-header">
    <h3>Freight Request Summary. </h3>
      <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
        <span class="pi pi-fw pi-times"></span>
      </button>
  </div>
  <form [formGroup]="RateForm">
    <div class="modal-dialog modal-lg">
      <div class="modal-content text-left">
        <div class="modal-body">
          <div class="ports">
            <div class="portleft">
              <div class="form-group">
                <label class="custom-labal "> From Port </label>
                <span>
                  {{frmport}}
                </span>
              </div>
              <span class="arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="54.963" height="6.658" viewBox="0 0 54.963 6.658">
                  <defs>
                    <style>
                      .a {
                        fill: #c2cadb;
                      }
                    </style>
                  </defs>
                  <path class="a" d="M-40.135,35.387c2.834.005,47.913.131,50.747.077-.305.308-.607.62-.9.94-.771.846.483,2.108,1.258,1.258.856-.939,1.773-1.816,2.714-2.669a.8.8,0,0,0-.033-1.245.959.959,0,0,0-.236-.241c-.874-.629-1.712-1.3-2.534-2-.87-.737-2.135.516-1.258,1.258q.548.464,1.109.912c-2.874.06-47.993-.068-50.867-.073A.89.89,0,0,0-40.135,35.387Z" transform="translate(40.996 -31.286)" />
                </svg>
              </span>
              <div class="form-group">
                <label class="custom-labal "> To Port </label>
                <span>
                  {{toport}}
                </span>
              </div>
            </div>
            <div class="portright">
              <div class="form-group">
                <span class="custom-labal ">Offered Rate :</span>
                <span class="btn bg-success">${{offeredamount}}</span>
              </div>
            </div>
          </div>
          <div class="row mt-3 mb-3">
            <div class="col-md-12 form-group">
              <button class="btn btn-signIn" data-toggle="modal" data-target=".view-poprereq" (click)="openReRequestModel()"> Re-Rate Request</button>
            </div>
          </div>
          <div class="stripTotal">
            <div class="row">
              <div class="col-md-4 form-group">
                <label class="custom-labal "> Total number of units </label>
                <input type="text" class="form-control" formControlName="noOfUnits" readonly />
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal "> Total LaneMeters </label>
                <input type="text" formControlName="totallanemeters" class="form-control" readonly />
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal "> Total Cubic Meters </label>
                <input type="text" class="form-control" formControlName="totalCubicmeters" readonly />
              </div>
            </div>
          </div>
          <h5 class="modal-title mb-3 mt-3 ">Freight request summary</h5>
          <div class="row ui-table">
            <div class="col-md-12 table-responsive   request-summary m-t-30">
              <table class="table table-striped ">
                <tr>
                  <th>Description</th>
                  <th>Rate Basis</th>
                  <th>Rate</th>
                  <th>Sum</th>
                </tr>
                <tr>
                  <td> Freght Rate </td>
                  <td>
                    {{selectedRatename}}
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="Calculatetotalfreightrate()" formControlName="freightrate" readonly />
                    <div *ngIf="hasError('freightrate', 'required') && submitted" class="invalid-Validation"> freight rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalrate" formControlName="ratetotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td> BAF </td>
                  <td>
                    {{selectedBAFname}}
                  </td>
                  <td>
                    <input type="text" class="form-control " placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="CalculatetotalBAFtrate()" formControlName="baf" readonly />
                    <div *ngIf="hasError('baf', 'required') && submitted" class="invalid-Validation"> BAF Rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalbaf" formControlName="baftotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td>
                    <!-- CAF --> Booking Fee
                  </td>
                  <td>
                    {{selectedCafname}}
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="CalculatetotalCAFrate()" formControlName="caf" readonly />
                    <div *ngIf="hasError('caf', 'required') && submitted" class="invalid-Validation"> Booking Fee is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalcaf" formControlName="caftotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td> THC </td>
                  <td>
                    {{selectedThcname}}
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="CalculatetotalTHCrate()" formControlName="thc" readonly />
                    <div *ngIf="hasError('thc', 'required') && submitted" class="invalid-Validation"> THC Rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalthc" formControlName="thctotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td> Other Charges </td>
                  <td>
                    {{selectedOtherchargesname}}
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="Calculatetotalothercharges()" formControlName="othercharges" readonly />
                    <div *ngIf="hasError('othercharges', 'required') && submitted" class="invalid-Validation"> Other Charges Rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalothercharges" formControlName="otherchargestotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td> Total Freight Cost </td>
                  <td></td>
                  <td></td>
                  <td>
                    <input type="text" class="form-control totalsumofallcost" formControlName="totalsumofallcost" readonly />
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <hr class="hr-1 ">
          <h5 class="modal-title  ">Freigh cost summary</h5>
          <div class="stripTotal">
            <div class="row ">
              <div class="col-md-3 form-group">
                <label class="custom-labal "> Cost per unit </label>
                <input type="text" class="form-control costperunt" formControlName="costperunit" readonly />
              </div>
              <div class="col-md-3 form-group">
                <label class="custom-labal "> Cost per CubicMeter </label>
                <input type="text" class="form-control costpercubicmeter" formControlName="costpercubicmeter" readonly />
              </div>
              <div class="col-md-3 form-group">
                <label class="custom-labal "> Total Cost </label>
                <input type="text" class="form-control totalsumofallcost" formControlName="totalsumofallcost" readonly />
              </div>
              <div class="col-md-3">
                <label class="custom-labal "> Freight Rate Validity </label>
                <!-- <input type="text" class="form-control" formControlName="freightratevalidity" readonly /> -->
                <p-calendar [readonlyInput]="true" formControlName="freightratevalidity" showIcon="true" showButtonBar="true" placeholder="Date" [minDate]="minDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}" icon="pi pi-calendar" iconPos="left" dateFormat="dd-mm-yy" [disabled]="true"></p-calendar>
                <div *ngIf="hasError('freightratevalidity', 'required') && submitted" class="invalid-Validation"> Freight Rate Validity Date is required. </div>
              </div>
            </div>
          </div>
          <hr class="hr-1 ">
          <div class="row ">
            <div class="col-md-12">
              <!-- <p><span class="text-orange">This rate quotation confirmation contains 11:</span>
                  the tariff ocean rates
                  global surcharges such as BAF, SRC and Canal Surcharge where applicable
                  validity date for these rates
                  standard Terms and Conditions that are applicable
                </p> -->
              <label class="custom-labal "> Disclaimer </label>
              <textarea readonly class="disclaimer" formControlName="disclaimer" rows="2" cols="100" pInputTextarea autoResize="autoResize" placeholder="               The rate terms are FLT (Full Liner Terms)
                 ENL Solutions reserve the right to correct any omission or clerical error made in the quotation process
                 This rate quote is not considered a binding agreement. A booking confirmation is provided based on space and equipment availability and is based on accepting the lines terms and conditions, which are available upon request.
                 Please note cargo is freighted on actual dimensions at the terminal upon delivery, which may result upon higher rate than quoted.
                 BAF and CAF is included in freight rate unless specified in quote.
                 THC and other charges are not included in freight rate and is for shippers account 
                 B/L Fee is not included in rate offer. Price is available on request
                 "></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #viewReRequestModel let-modal>
  <div class="modal-header">
    <h3>Reason For Re-Request</h3>
    <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
      <span class="pi pi-fw pi-times"></span>
    </button>
  </div>
  <form [formGroup]="ratererequestform" (ngSubmit)="SubmitReason()">
      <div class="modal-dialog modal-md">
        <div class="modal-content text-left">
          <div class="modal-body">
            <textarea class="form-control" placeholder="Add Reason" formControlName="resonforrerequest"
              style="height: 103px;"> </textarea>
            <div *ngIf="hasErrors('resonforrerequest', 'required') && submitted" class="invalid-Validation">
              Reason required.
            </div>
          </div>
  
          <div class="modal-footer">
            <button type="submit" class="btn btn-signIn">Send</button>
          </div>
        </div>
      </div>
    </form>

</ng-template>

<ng-template #viewRateRequestModel let-modal>
  <div class="modal-header">
    <h3>Freight Request Summary</h3>
    <div class="float-right btn btn-signIn" *ngIf="statusrate == raterqueststatus.ReRequest">
      <strong>Re-Rate Requested</strong>
    </div>
    <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
      <span class="pi pi-fw pi-times"></span>
    </button>
  </div>
  <form [formGroup]="RateForm" (ngSubmit)="SubmitRate()">
    <div class="modal-dialog modal-lg">
      <div class="modal-content text-left">
        <div class="modal-body">
          <div class="ports">
            <div class="portleft">
              <div class="form-group">
                <label class="custom-labal "> From Port </label>
                <span>
                  {{frmport}}
                </span>
              </div>
              <span class="arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="54.963" height="6.658" viewBox="0 0 54.963 6.658">
                  <defs>
                    <style>
                      .a {
                        fill: #c2cadb;
                      }
                    </style>
                  </defs>
                  <path class="a" d="M-40.135,35.387c2.834.005,47.913.131,50.747.077-.305.308-.607.62-.9.94-.771.846.483,2.108,1.258,1.258.856-.939,1.773-1.816,2.714-2.669a.8.8,0,0,0-.033-1.245.959.959,0,0,0-.236-.241c-.874-.629-1.712-1.3-2.534-2-.87-.737-2.135.516-1.258,1.258q.548.464,1.109.912c-2.874.06-47.993-.068-50.867-.073A.89.89,0,0,0-40.135,35.387Z" transform="translate(40.996 -31.286)" />
                </svg>
              </span>
              <div class="form-group">
                <label class="custom-labal "> To Port </label>
                <span>
                  {{toport}}
                </span>
              </div>
            </div>
            <div class="portright">
              <div class="form-group">
                <span class="custom-labal ">Offered Rate :</span>
                <span class="btn bg-success">${{offeredamount}}</span>
              </div>
              <div class="form-group" *ngIf="statusrate == raterqueststatus.ReRequest">
                <span class="custom-labal ">Reason For Re- Request:</span>
                <span>
                  <strong>{{offeredRateReason}}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="row mt-3 mb-3"></div>
          <div class="form-group m-t-30">
            <h5 class="modal-title mb-3 mt-3 ">User Details</h5>
            <hr class="hr-1 ">
            <div *ngIf="showUserDetails" class="row m-t-30">
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Name </label>
                <div class="pRel">
                  {{rateRequestUserDetail?.firstName}} {{rateRequestUserDetail?.lastName}}
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Company </label>
                <div class="pRel">
                  {{rateRequestUserDetail?.companyName}}
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Phone </label>
                <div class="pRel">
                  {{rateRequestUserDetail?.phoneNumber}}
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Email </label>
                {{rateRequestUserDetail?.email}}
              </div>
            </div>
            <div *ngIf="!showUserDetails" class="row m-t-30">
              <div class="col-md-12 form-group">
                <b>Customer Details Locked</b>
                <br /> Only <b>Elite Members</b> have direct access to customer contact information. To unlock the customer details, please submit your quotation. The customer will review your offer and may choose to contact you directly. Upgrade to Elite to see customer details instantly and receive priority visibility for your quotes.
              </div>
            </div>
          </div>
          <div class="form-group m-t-30">
            <h5 class="modal-title mb-3 mt-3 ">Consignment Details</h5>
            <hr class="hr-1 ">
            <div class="row m-t-30">
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Cargo Class </label>
                <div class="pRel">
                  {{cargoclassname}}
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Cargo Segment </label>
                <div class="pRel">
                  {{cargosegmentname}}
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Condition </label>
                {{conditionname}}
              </div>
            </div>
            <div class="row m-t-30">
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Cargo Movement Status </label>
                {{cargoMovementStatus}}
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> When can cargo be in loadport? </label>
                <div class="pRel">
                  {{whencargocanlandportname | date: "dd-MM-yyyy"}}
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Number of Units </label>
                {{numberofunitname}}
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Shipping Lines </label>
                <div class="pRel">
                  {{shippinglinename}}
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Length(m) </label>
                <div class="pRel">
                  {{cargolength}}
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal"> Width(m) </label>
                <div class="pRel">
                  {{cargowidth}}
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label class="custom-labal"> Height(m) </label>
                <div class="pRel">
                  {{cargoheight}}
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label class="custom-labal"> Weight(mt) </label>
                <div class="pRel">
                  {{cargoweight}}
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label class="custom-labal"> Package And Description </label>
                <div class="pRel">
                  {{packageAndDescription}}
                </div>
              </div>
              <div class="col-md-3 form-group">
                <span *ngFor="let item of fileNames">
                  <a href="{{downloadBaseUrl}}{{item}}">
                    <img src="../../../assets/images/fileicon.png" />
                  </a>
                </span>
              </div>
            </div>
            <hr class="hr-1 ">
            <div class="stripTotal">
              <div class="row">
                <div class="col-md-4 form-group">
                  <label class="custom-labal "> Total number of units </label>
                  <input type="text" class="form-control" formControlName="noOfUnits" readonly />
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal "> Total LaneMeters </label>
                  <input type="text" formControlName="totallanemeters" class="form-control" readonly />
                </div>
                <div class="col-md-4 form-group">
                  <label class="custom-labal "> Total Cubic Meters </label>
                  <input type="text" class="form-control" formControlName="totalCubicmeters" readonly />
                </div>
              </div>
            </div>
          </div>
          <hr class="hr-1 ">
          <h5 class="modal-title mb-3 mt-3 ">Freight request summary</h5>
          <div class="row ui-table">
            <div class="col-md-12 table-responsive   request-summary m-t-30">
              <table class="table table-striped nbr ">
                <tr>
                  <th>Description</th>
                  <th>Rate Basis</th>
                  <th>Rate</th>
                  <th>Sum</th>
                </tr>
                <tr>
                  <td> Freight Rate </td>
                  <td>
                    <div class="pRel">
                      <p-dropdown [options]="freightratedropdown" formControlName="freightratebasis" class="select-dropdown-sec " placeholder="Rate Basis" [filter]="false" (onChange)="Calculatetotalfreightrate()"></p-dropdown>
                      <span class="downArrow">
                        <img src="../../../../assets/images/arrow.png" />
                      </span>
                    </div>
                    <div *ngIf="hasError('freightratebasis', 'required') && submitted" class="invalid-Validation"> freight rate basis is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control " placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="Calculatetotalfreightrate()" formControlName="freightrate" />
                    <div *ngIf="hasError('freightrate', 'required') && submitted" class="invalid-Validation"> freight rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalrate" formControlName="ratetotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td> BAF </td>
                  <td>
                    <div class="pRel">
                      <p-dropdown [options]="otherratedropdown" class="select-dropdown-sec" aria-readonly="!admin" formControlName="bafbasis" placeholder="Rate Basis" (onChange)="CalculatetotalBAFtrate()" [filter]="false"></p-dropdown>
                      <span class="downArrow">
                        <img src="../../../../assets/images/arrow.png" />
                      </span>
                    </div>
                    <div *ngIf="hasError('bafbasis', 'required') && submitted" class="invalid-Validation"> BAF Basis is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control " placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="CalculatetotalBAFtrate()" formControlName="baf" />
                    <div *ngIf="hasError('baf', 'required') && submitted" class="invalid-Validation"> BAF Rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalbaf" formControlName="baftotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td>
                    <!-- CAF --> Booking Fee
                  </td>
                  <td>
                    <div class="pRel">
                      <p-dropdown [options]="otherratedropdown" (onChange)="CalculatetotalCAFrate()" class="select-dropdown-sec" formControlName="cafbasis" placeholder="Rate Basis" [filter]="false" [readonly]="iscafbasisReadonly == true"></p-dropdown>
                      <span class="downArrow">
                        <img src="../../../../assets/images/arrow.png" />
                      </span>
                    </div>
                    <div *ngIf="hasError('cafbasis', 'required') && submitted" class="invalid-Validation"> Booking Fee is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="CalculatetotalCAFrate()" formControlName="caf" />
                  </td>
                  <td>
                    <input type="text" class="form-control totalcaf" formControlName="caftotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td> THC </td>
                  <td>
                    <div class="pRel">
                      <p-dropdown [options]="otherratedropdown" formControlName="thcbasis" class="select-dropdown-sec" (onChange)="CalculatetotalTHCrate()" placeholder="Rate Basis" [filter]="false"></p-dropdown>
                      <span class="downArrow">
                        <img src="../../../../assets/images/arrow.png" />
                      </span>
                    </div>
                    <div *ngIf="hasError('thcbasis', 'required') && submitted" class="invalid-Validation"> THC Basis Rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="CalculatetotalTHCrate()" formControlName="thc" />
                    <div *ngIf="hasError('thc', 'required') && submitted" class="invalid-Validation"> THC Rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalthc" formControlName="thctotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td> Other Charges </td>
                  <td>
                    <div class="pRel">
                      <p-dropdown [options]="otherratedropdown" formControlName="otherchargesbasis" class="select-dropdown-sec" placeholder="Rate Basis" (onChange)="Calculatetotalothercharges()" [filter]="false"></p-dropdown>
                      <span class="downArrow">
                        <img src="../../../../assets/images/arrow.png" />
                      </span>
                    </div>
                    <div *ngIf="hasError('otherchargesbasis', 'required') && submitted" class="invalid-Validation"> Other Charges Basis Rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="Calculatetotalothercharges()" formControlName="othercharges" />
                    <div *ngIf="hasError('othercharges', 'required') && submitted" class="invalid-Validation"> Other Charges Rate is required </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalothercharges" formControlName="otherchargestotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td> Total Freight Cost </td>
                  <td></td>
                  <td></td>
                  <td>
                    <input type="text" class="form-control totalsumofallcost" formControlName="totalsumofallcost" readonly />
                  </td>
                </tr>
                <tr>
                  <td colspan="4" height="40"></td>
                </tr>
              </table>
            </div>
          </div>
          <hr class="hr-1 ">
          <h5 class="modal-title  ">Freight cost summary</h5>
          <div class="stripTotal">
            <div class="row ">
              <div class="col-md-3 form-group">
                <label class="custom-labal "> Cost per unit </label>
                <input type="text" class="form-control costperunt" formControlName="costperunit" readonly />
              </div>
              <div class="col-md-3 form-group">
                <label class="custom-labal "> Cost per CubicMeter </label>
                <input type="text" class="form-control costpercubicmeter" formControlName="costpercubicmeter" readonly />
              </div>
              <div class="col-md-3 form-group">
                <label class="custom-labal "> Total Cost </label>
                <input type="text" class="form-control totalsumofallcost" formControlName="totalsumofallcost" readonly />
              </div>
              <div class="col-md-3">
                <label class="custom-labal "> Freight Rate Validity </label>
                <p-calendar [readonlyInput]="true" formControlName="freightratevalidity" showIcon="true" showButtonBar="true" placeholder="Date" [minDate]="minDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}" icon="pi pi-calendar" iconPos="left" dateFormat="dd-mm-yy"></p-calendar>
                <div *ngIf="hasError('freightratevalidity', 'required') && submitted" class="invalid-Validation"> Freight Rate Validity Date is required. </div>
              </div>
            </div>
          </div>
          <hr class="hr-1 ">
          <div class="row ">
            <div class="col-md-12">
              <label class="custom-labal "> Disclaimer </label>
              <textarea class="disclaimer" formControlName="disclaimer" rows="2" cols="100" pInputTextarea autoResize="autoResize" placeholder="               The rate terms are FLT (Full Liner Terms)
                 ENL Solutions reserve the right to correct any omission or clerical error made in the quotation process
                 This rate quote is not considered a binding agreement. A booking confirmation is provided based on space and equipment availability and is based on accepting the lines terms and conditions, which are available upon request.
                 Please note cargo is freighted on actual dimensions at the terminal upon delivery, which may result upon higher rate than quoted.
                 BAF and CAF is included in freight rate unless specified in quote.
                 THC and other charges are not included in freight rate and is for shippers account 
                 B/L Fee is not included in rate offer. Price is available on request
                 "></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-signIn ">Save</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
  <!-- <button data-toggle="modal" data-target=".view-offredrate" id="select" ></button> -->